import React, { useState, useEffect } from 'react';
import { SCHEDULE_WEEK_CODE } from '@common/utils/schedule';
import { Link } from 'react-router-dom';
import { getScheduleList } from '@api/api';

const HomeMainSchedule = () => {
  const { year, month, dayIndex: initialDayIndex } = $utils.getTodayInfo();

  const [dayIndex, setDayIndex] = useState(initialDayIndex);
  const [scheduleInfos, setScheduleInfos] = useState([]);

  const selectedSchedule = scheduleInfos[dayIndex];
  const daySchedules = selectedSchedule?.schedules || [];

  useEffect(() => {
    let isMounted = true;

    const fetchSchedules = async () => {
      const todayDateString = $utils.formatBoardDate(new Date());

      const payload = {
        atvCd: 'Z000',
        activObjNm: '',
        periodCd: SCHEDULE_WEEK_CODE,
        aldyYn: 'N',
        activProgrsStatCd: '',
        activContn: '',
        selectedDd: todayDateString,
      };

      const response = await getScheduleList({ payload });
      const isSuccess = $utils.checkApiSuccess(response);

      if (isSuccess) {
        const data = $utils.getApiData(response);
        const scheduleInfos = $utils.transformSchedules(data);
        if (isMounted) setScheduleInfos(scheduleInfos);
      }
    };

    fetchSchedules();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="half app-box-main">
      <div className="ico-group-2 ico-new-cal">
        <h3 className="tit3">
          {year}년 {month}월
        </h3>
      </div>

      <div className="date-work">
        {scheduleInfos.map(({ number, text, schedules, isToday }, index) => (
          <dl
            key={index}
            className={$classNames('date-box', { yellow: index === dayIndex })}
            onClick={() => setDayIndex(index)}
          >
            <dt>
              <div>{text}</div>
              <div>{number}일</div>
            </dt>
            <dd>
              {isToday && <div className="todaybox">Today</div>}

              <span>
                <strong className="work-num">{schedules.length}</strong>건
              </span>
            </dd>
          </dl>
        ))}
      </div>

      {daySchedules && daySchedules.length > 0 ? (
        <ul className="notice-board-list">
          {daySchedules.map(
            ({
              activMngSno,
              activProgrsStatNm,
              activObjNm,
              activContn,
              visitStrtTtm,
              color,
            }) => (
              <li key={activMngSno} className="new color-list">
                <Link to={`/schedule/edit?scheduleId=${activMngSno}`}>
                  <span className="color-info-wrap">
                    <span className={$classNames('list-style', color)}>●</span>
                    <span className="color-info">{activProgrsStatNm}</span>
                    <span className="graytime">
                      {$utils.formatVisitTime(visitStrtTtm)}
                    </span>
                    <span className="namebold">{activObjNm}</span>
                    <span className="color-info-con">{activContn}</span>
                  </span>
                </Link>
              </li>
            ),
          )}
        </ul>
      ) : (
        <div className="no-data link">
          등록된 활동이 없습니다.
          <Link to={`/schedule/write?dateStr=${selectedSchedule?.dateString}`}>
            활동등록하기
          </Link>
        </div>
      )}

      <Link className="ico-arrow" to="/schedule">
        더보기
      </Link>
    </div>
  );
};

export default HomeMainSchedule;
